module.exports = __webpack_public_path__ + "media/images/landing/client_TMobile-8ab2874815e9d2983c9b6630b5d15ad0.png";